export default defineNuxtRouteMiddleware((to, from) => {
  try {
    // Hot Fix for Vercel Deployment
    if (to.fullPath.includes('+')) to.fullPath = to.fullPath.replace(/\+/g, '%20');
  } catch (e) {
    console.log('Invalid query parameters:', e);
  }
});
